import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import CategoryService from '@/services/CatalogServices/CategoryService';
import { extractError } from '@/helpers/extractApiError';

const model = {
    id: null,
    submitting: false,
    error: null,
    successOnDelete: '',
};

export const deleteCategory = createAsyncThunk(
    'category/deleteCategory',
    async (categoryId, { rejectWithValue }) => {
        try {
            const response = await CategoryService.deleteCategory(categoryId);
            return {
                categoryId,
                data: response.data,
            };
        } catch (error) {
            return rejectWithValue(extractError(error));
        }
    },
);

const deleteCategorySlice = createSlice({
    name: 'deleteCategory',
    initialState: model,
    reducers: {
        resetDeleteCategoryStateOnError: (state) => {
            state.error = null;
        },
        resetDeleteCategoryStateOnSuccess: (state) => {
            state.successOnDelete = '';
        },
    },
    extraReducers: (builder) => {
        // delete category
        builder.addCase(deleteCategory.pending, (state, action) => {
            state.id = action.meta.arg;
            state.submitting = true;
        }).addCase(deleteCategory.fulfilled, (state) => {
            state.id = null;
            state.submitting = false;
            state.successOnDelete = 'Category deleted successfully!';
        }).addCase(deleteCategory.rejected, (state, action) => {
            state.submitting = false;
            state.error = extractError(action);
        });
    },
});

export const {
    resetDeleteCategoryStateOnError,
    resetDeleteCategoryStateOnSuccess,
} = deleteCategorySlice.actions;

export default deleteCategorySlice.reducer;
